import React, { Component } from 'react';
import { ISecutionQuestions } from 'src/models/pre-acceptance.interface';

interface IProps {
  statusHandler: any;
  securityQuestions: ISecutionQuestions[];
  language: string;
  multiLang: any;
  languageCode: string;
  handleLanguageChange: any;
  step: number;
}

interface IState {
  questions: any[];
  isValid: boolean;
  correctAnswers: boolean;
}

export class SecurityDeclarationComponent extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    const securityQuestions = props.securityQuestions || [];

    const qs = securityQuestions.map((q) => {
      return {
        questionText: q.questionText,
        options: [...q.answers],
        answer: '',
      };
    });

    this.state = {
      questions: qs,
      isValid: false,
      correctAnswers: true,
    };
  }

  handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    option: string,
    index: number
  ) => {
    const { value } = event.target;
    const { language, multiLang } = this.props;
    const answer = multiLang['Yes' + language] === value ? 'Yes' : 'No';

    const { questions } = this.state;

    const updatedQuestions = questions.map((q, i) => {
      if (i === index) {
        return {
          ...q,
          answer: answer,
        };
      }

      return {
        ...q,
      };
    });

    const isAnyYes = updatedQuestions.find((q) => q.answer === 'Yes');
    const areAllNos = updatedQuestions.filter((q) => q.answer === 'No');

    const isValid = areAllNos.length === updatedQuestions.length;

    this.setState((prevState) => ({
      ...prevState,
      questions: updatedQuestions,
      isValid: isValid,
      correctAnswers: !isAnyYes,
    }));
  };

  render() {
    const { language, multiLang, step } = this.props;
    const { questions } = this.state;

    return (
      <>
        <div className='preStep'>
          <div className='preStep__title'>
            <h2>{multiLang[`securityDeclarationTitle${language}`]}</h2>
          </div>
          <div className='preStep__panel'>
            <div className='preStep__header'>
              <h2>{multiLang[`securityDeclarationPanelTitle${language}`]}</h2>
            </div>
            <div className='preStep__body'>
              <div className='preStep__declaration'>
                <ul>
                  {questions.map((q, index) => (
                    <li key={index + 1}>
                      <div className='item-text'>
                        <span>{index + 1}</span>
                        <p>{multiLang[`${q.questionText + language}`]} </p>
                      </div>
                      <div className='item-action'>
                        {q.options.map((o) => (
                          <div
                            className='form__control'
                            key={index}
                          >
                            <input
                              key={index}
                              type='radio'
                              name={`option-${index}`}
                              id={`option-${o.answerText}-${index}`}
                              value={multiLang[`${o.answerText + language}`]}
                              checked={
                                q.answer ===
                                o.answerText
                              }
                              onChange={(event) =>
                                this.handleChange(
                                  event,
                                  `option-${index}`,
                                  index
                                )
                              }
                            />
                            <label
                              htmlFor={`option-${o.answerText}-${index}`}
                            >
                              {multiLang[`${o.answerText + language}`]}
                            </label>
                          </div>
                        ))}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              {!this.state.correctAnswers && (
                <div className='grayBox bg-orange'>
                  <p>{multiLang[`securityDeclarationMessage${language}`]}</p>
                </div>
              )}

              <div className='preStep__footer'>
                <button
                  className='btn btn__purple'
                  disabled={!this.state.isValid}
                  onClick={() => this.props.statusHandler(step + 1)}
                >
                  {multiLang[`securityDeclarationButton${language}`]}
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default SecurityDeclarationComponent;



// WEBPACK FOOTER //
// ./src/components/security-declaration/security-declaration.component.tsx